export const generateQueryString = (params: any) => {
  const queryString = new URLSearchParams(params);
  return `?${queryString?.toString()}`;
};
